import React, { useState, useEffect } from "react";
import { KeyRound } from "lucide-react";
import NavbarGenerale from "./Navbar.jsx";
import Input from "../../components/Input";
import PopUp from "../../components/PopUp";
import TempStorage from "../../components/Storage";
import DeviceDetector from "../../components/DeviceDetector.jsx";
import Alert from "../../components/Alert";
import Button from "../../components/Button.jsx";
import { useNavigate } from "react-router-dom";
import { Device } from '@capacitor/device';
import { useDarkMode } from "../../components/DarkModeContext.jsx";

let infoUtente = {};

const Login = () => {
    const [isPopUpAppVisible, setIsPopUpAppVisible] = useState(false);
    const [isPopUpAlertVisible, setIsPopUpAlertVisible] = useState(false);
    const [isResocontoVisible, setIsResocontoVisible] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [nuovaLicenza, setNuovaLicenza] = useState('');
    const [infoLicenza, setInfoLicenza] = useState(null);
    const [installPrompt, setInstallPrompt] = useState(null);
    const devices = {
        MacOS: ["/img/MacOS.png", "/downloads/MANTEGO.dmg"],
        Windows: ["/img/Windows.png", "/downloads/MANTEGO.exe"],
        Linux: ["/img/Linux.png", "/downloads/MANTEGO.deb"],
        Android: ["/img/Android.png", "/downloads/MANTEGO.apk"],
        iOS: ["/img/iOS.png"],
    };
    const navigate = useNavigate();
    const { darkMode, loadCorrectTheme } = useDarkMode();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        if (TempStorage.exists('authAlert')) {
            setAlertInfo({ type: "info", text: TempStorage.get('authAlert'), onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
        TempStorage.clear();

        const handleBeforeInstallPrompt = (event) => {
            // Previene il prompt automatico del browser
            event.preventDefault();
            // Salva l'evento per utilizzarlo successivamente
            setInstallPrompt(event);
        };

        // Listener per l'evento di installazione
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };

    }, []);

    const handleLogin = async () => {
        try {
            const infoDevice = await Device.getId();
            const r = await fetch('/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: email, Password: password, CodiceDispositivo: infoDevice["identifier"] }),
            });
            const rd = await r.json();
            if (r.status === 500) {
                setAlertInfo({ type: "error", text: rd["error"], onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setEmail('');
                setPassword('');
            }
            else if (r.status === 201) {
                infoUtente = rd;
                setIsPopUpAlertVisible(true);
            }
            else if (r.status === 202) {
                setAlertInfo({ type: "warning", text: rd["warning"], onClose: () => { successLogin(rd["user"]) }, needConfirm: false });
                setShowAlert(true);
            }
            else if (r.status === 200) {
                successLogin(rd);
            }
        } catch (error) {
            console.error(error);
            setAlertInfo({ type: "error", text: "Errore durante il login", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            setEmail('');
            setPassword('');
        }
    };

    const successLogin = (data) => {
        loadCorrectTheme(false, data['ID']);
        switch (data['Livello']) {
            case 'Manager':
                TempStorage.set('tokenManager', data['ID']);
                document.cookie = `tokenManager=${data['ID']}; path=/;`;
                navigate('/manager/dash');
                break;
            case 'IS':
                TempStorage.set('tokenDev', data['ID']);
                document.cookie = `tokenDev=${data['ID']}; path=/;`;
                navigate('/dev/dash');
                break;
            case 'Utente':
                TempStorage.set('tokenUser', data['ID']);
                document.cookie = `tokenUser=${data['ID']}; path=/;`;
                navigate('/utente/dash');
                break;
            case 'Venditore':
                TempStorage.set('tokenVenditore', data['ID']);
                document.cookie = `tokenVenditore=${data['ID']}; path=/;`;
                navigate('/venditore/dash');
                break;
            default:
                setAlertInfo({ type: "error", text: "Livello utente non riconosciuto", onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setEmail('');
                setPassword('');
                break;
        }
    };

    const checkCodice = async () => {
        try {
            const r = await fetch('/checkCodiceAttivazione', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodiceAtt: nuovaLicenza }),
            });

            const rd = await r.json();

            if (r.status === 200) {
                if (rd[0].Obsoleto) {
                    setAlertInfo({ type: "warning", text: 'Licenza obsoleta, contatta il tuo manager', onClose: () => setShowAlert(false), needConfirm: false });
                    setShowAlert(true);
                    setNuovaLicenza('');
                    return;
                };

                if (rd[0].DataAttivazione !== null) {
                    setAlertInfo({ type: "warning", text: 'Licenza già attivata', onClose: () => setShowAlert(false), needConfirm: false });
                    setShowAlert(true);
                    setNuovaLicenza('');
                    return;
                };

                setInfoLicenza(rd[0]);
                setIsResocontoVisible(true);
            }
            else {
                setAlertInfo({ type: "error", text: rd["error"], onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: 'Errore nella connessione al server', onClose: () => {window.location.reload();}, needConfirm: false });
            setShowAlert(true);
        }
    };

    const confirmPopUpLicenza = async () => {
        try {
            const r = await fetch('/aggiornaLicenzaDominio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ IDLicenza: infoLicenza.ID, CodiceDominio: infoUtente.CodiceDominio }),
            });

            if (r.status === 500) {
                const rd = await r.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => {window.location.reload();}, needConfirm: false });
                setShowAlert(true);
            }
            else {
                window.location.reload();
            }
        } catch (error) {
            setAlertInfo({ type: "error", text: 'Errore nella connessione al server', onClose: () => {window.location.reload();}, needConfirm: false });
            setShowAlert(true);
            console.log(error);
        }
    };

    return (
        <div className="h-[100svh]">
            <NavbarGenerale />
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto flex flex-col justify-center items-center">
                <img src={darkMode ? "/img/FirmaLight.png" : "/img/FirmaDark.png"} className="w-[90%] md:w-[50%]" />
                <Input
                    label="Email"
                    value={email}
                    setValue={(value) => setEmail(value)}
                    type="text"
                    classes="w-[90%] md:w-[50%] mt-4"
                />
                <Input
                    label="Password"
                    value={password}
                    setValue={(value) => setPassword(value)}
                    type="password"
                    classes="w-[90%] md:w-[50%] mt-4"
                    keyDownAction={(e) => {
                        if (e.key === 'Enter') {
                            handleLogin();
                        }
                    }}

                />
                <Button type="full" classes="w-[90%] md:w-[50%] mt-4" onClick={handleLogin}>
                    LOGIN<KeyRound className="ml-1" size={20} />
                </Button>
                <p className="mt-4">Non hai le credenziali?</p>
                <p>
                    Contatta il tuo manager oppure
                    <span className="text-blue-600 underline font-semibold hover:cursor-pointer ml-1" onClick={() => navigate('/crea')}>attiva una licenza</span>
                </p>
                <p className="mt-1">
                    Non hai una licenza?
                    <span className="text-blue-600 underline font-semibold hover:cursor-pointer ml-1" onClick={() => {
                        window.open('https://www.dsatechnology.it/mantego/', '_blank');
                    }}>
                        Acquistane una
                    </span>
                </p>
                <span className="text-blue-600 underline font-semibold hover:cursor-pointer mt-4" onClick={() => setIsPopUpAppVisible(true)}>SCARICA LA NOSTRA APP</span>
                <PopUp title="SCARICA L'APPLICAZIONE"
                    isVisible={isPopUpAppVisible}
                    setIsVisible={() => setIsPopUpAppVisible(false)}
                    needConfirm={false}
                >
                    <>
                        <img
                            src={devices[DeviceDetector.getOS()][0]}
                            className={`w-[30%] mx-auto hover:cursor-pointer rounded ${darkMode ? 'invert' : ''} active:scale-95 transition-all`}
                            onClick={() => {
                                if (DeviceDetector.getOS() === 'iOS') {
                                    setAlertInfo({ type: "info", text: "L'applicazione arriverà presto su iOS, intanto potete installare l'applicazione web tramite Safari in questo modo: \n1. Cliccare sul pulsante 'Condividi' in basso al centro \n2. Cliccare su 'Aggiungi a schermata Home' \n(Se questa azione non fosse disponibile inizialmente è possibile aggiungerla andando sul pulsante 'Modifica azioni' che si trova nella parte inferiore della scheda di condivisione.) \n3. Cliccare su 'Aggiungi' in alto a destra", onClose: () => setShowAlert(false), needConfirm: true, onConfirm: () => setShowAlert(false) });
                                    setShowAlert(true);
                                }
                                else {
                                    window.location.href = devices[DeviceDetector.getOS()][1];
                                }
                            }}
                        />
                        <div className="relative flex items-center justify-center w-full mb-4">
                            <div className="absolute w-full h-1 bg-gray-200 dark:bg-neutral-800 rounded"></div>
                            <span className="relative px-3 bg-gray-100 dark:bg-neutral-900 ">oppure</span>
                        </div>
                        <div className="flex items-center">
                            {
                                Object.keys(devices).map((device) => {
                                    if (device === DeviceDetector.getOS()) return null;
                                    return (
                                        <img
                                            src={devices[device][0]}
                                            className={`w-[20%] mx-auto hover:cursor-pointer rounded ${darkMode ? 'invert' : ''} active:scale-95 transition-all`}
                                            onClick={() => {
                                                if (device === 'iOS') {
                                                    setAlertInfo({ type: "info", text: "L'applicazione arriverà presto su iOS, intanto potete installare l'applicazione web tramite Safari in questo modo: \n1. Cliccare sul pulsante 'Condividi' in basso al centro \n2. Cliccare su 'Aggiungi a schermata Home' \n(Se questa azione non fosse disponibile inizialmente è possibile aggiungerla andando sul pulsante 'Modifica azioni' che si trova nella parte inferiore della scheda di condivisione.) \n3. Cliccare su 'Aggiungi' in alto a destra", onClose: () => setShowAlert(false), needConfirm: true, onConfirm: () => setShowAlert(false) });
                                                    setShowAlert(true);
                                                }
                                                else {
                                                    window.location.href = devices[device][1];
                                                }
                                            }}
                                        />
                                    );
                                })
                            }
                        </div>
                    </>
                </PopUp>
                <PopUp title="LICENZA SCADUTA"
                    isVisible={isPopUpAlertVisible}
                    setIsVisible={() => setIsPopUpAlertVisible(false)}
                    needConfirm={true}
                    confirmAction={confirmPopUpLicenza}
                    cancelAction={() => { window.location.reload() }}
                    cannotClose={!isResocontoVisible}
                >
                    <>
                        <div className="flex flex-col items-center justify-center">
                            <Input
                                label="Nuova licenza *"
                                value={isResocontoVisible ? infoLicenza["CodiceAttivazione"] : nuovaLicenza}
                                setValue={(value) => setNuovaLicenza(value)}
                                type="number"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={infoLicenza !== null}
                                error={false}
                                blurAction={checkCodice}
                            />
                        </div>
                        {
                            isResocontoVisible && (
                                <div className="flex flex-col items-center">
                                    <div className="w-[80%] md:w-[70%] mt-3">
                                        <p className="flex justify-between">
                                            Nome :
                                            <span className="font-semibold">{infoLicenza["Nome"]}</span>
                                        </p>
                                        <p className="flex justify-between mt-1">
                                            Descrizione :
                                            <span className="font-semibold">{infoLicenza["Descrizione"]}</span>
                                        </p>
                                    </div>
                                </div>
                            )
                        }
                    </>
                </PopUp>
            </div>
        </div>
    )
};

export default Login